import { render, staticRenderFns } from "./FrameworkControl.vue?vue&type=template&id=60df681e&scoped=true&"
import script from "./FrameworkControl.vue?vue&type=script&lang=js&"
export * from "./FrameworkControl.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60df681e",
  null
  
)

export default component.exports